import {CreateCounterparty, Counterparty, CounterpartyId} from "../../Types";
import {invalidateQueries, q} from "../../state";
import {CURRENT_REGION} from "../../utils/region";
import jsonApi from "../jsonApi";

export async function list() {
  return await jsonApi.get<Counterparty[]>(`/region/${CURRENT_REGION}/api/vendor_toolkit/counterparties`);
}

export async function get(counterpartyId: CounterpartyId) {
  return await jsonApi.get<Counterparty>(
    `/region/${CURRENT_REGION}/api/vendor_toolkit/counterparties/${counterpartyId}`,
  );
}

export async function create(counterparty: CreateCounterparty) {
  const res = await jsonApi.post<Counterparty>(
    `/region/${CURRENT_REGION}/api/vendor_toolkit/counterparties`,
    counterparty,
  );
  await invalidateQueries([q.vendorToolkit.counterparties.filter()]);
  return res;
}

export async function updateName(counterpartyId: CounterpartyId, name: string) {
  const res = await jsonApi.post<"ok">(
    `/region/${CURRENT_REGION}/api/vendor_toolkit/counterparties/${counterpartyId}/name`,
    name,
  );
  await invalidateQueries([
    q.vendorToolkit.counterparties.filter(),
    q.vendorToolkit.counterparty.filter(counterpartyId),
  ]);
  return res;
}

export async function updateLanguageCode(counterpartyId: CounterpartyId, languageCode: string) {
  const res = await jsonApi.post<"ok">(
    `/region/${CURRENT_REGION}/api/vendor_toolkit/counterparties/${counterpartyId}/language_code`,
    languageCode,
  );
  await invalidateQueries([
    q.vendorToolkit.counterparties.filter(),
    q.vendorToolkit.counterparty.filter(counterpartyId),
  ]);
  return res;
}

export async function updateUrl(counterpartyId: CounterpartyId, url: string) {
  const res = await jsonApi.post<"ok">(
    `/region/${CURRENT_REGION}/api/vendor_toolkit/counterparties/${counterpartyId}/url`,
    url,
  );
  await invalidateQueries([
    q.vendorToolkit.counterparties.filter(),
    q.vendorToolkit.counterparty.filter(counterpartyId),
  ]);
  return res;
}
